module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/social-media/social-media.component.scss
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/social-media/social-media.component.scss
// module chunks = main